import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { updateBodyClass } from 'src/helpers';
import { ADMIN_URL, BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import withRouter from 'src/utils/withRouter';

//Lazy Load
const AdminContainer = lazy(() => import('src/ui/features/Admin/containers/AdminContainer'));
const AdminContainerWithRouter = withRouter(AdminContainer);

class AdminRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.ADMIN);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.ADMIN);
  }

  render() {
    return (
      <Layout headerName={'Administration'}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Routes>
            <Route path="/*" element={<AdminContainerWithRouter />} />
          </Routes>
        </Suspense>
      </Layout>
    );
  }
}

export default AdminRoot;
